import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '../environments/environments';
import { Observable } from 'rxjs';

import {
  ReservationPayload,
  IBranchResponse,
  BranchStoreModality,
  State,
  PlaceByDayMap,
} from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ReservationService {
  readonly #http = inject(HttpClient);

  getAllStates(): Observable<State[]> {
    return this.#http.get<State[]>(`${environment.RESERVE_URL}/Place/States`);
  }

  getCitiesByState(acronymState: string): Observable<State[]> {
    return this.#http.get<State[]>(`${environment.RESERVE_URL}/Place/Cities/State/${acronymState}`);
  }

  getBranchesByCity(city: string): Observable<State[]> {
    return this.#http.get<State[]>(`${environment.RESERVE_URL}/Place/Branches/City/${city}`);
  }

  getHallByBranch(branchId: string): Observable<State[]> {
    return this.#http.get<State[]>(`${environment.RESERVE_URL}/Place/Halls/Branch/${branchId}`);
  }

  getAvailablePlacesByDay(branchId: string, hallId: string): Observable<PlaceByDayMap> {
    console.log('binding');
    return this.#http.get<PlaceByDayMap>(
      `${environment.RESERVE_URL}/Place/Branch/${branchId}/Hall/${hallId}/Dates`
    );
  }

  getPeoples(hallId: string, branchId: string): Observable<any> {
    return this.#http.get<any>(`${environment.RESERVE_URL}/Place/Branch/${branchId}/Hall/${hallId}`);
  }

  getDates(hallId: string, branchId: string, quantity: number): Observable<any> {
    return this.#http.get<any>(
      `${environment.RESERVE_URL}/Availability/Dates?BranchId=${branchId}&HallId=${hallId}&Quantity=${quantity}`
    );
  }

  getHour(hallId: string, branchId: string, quantity: number, day: string): Observable<any> {
    return this.#http.get<any>(
      `${environment.RESERVE_URL}/Availability/Hours?BranchId=${branchId}&HallId=${hallId}&Quantity=${quantity}&Date=${day}`
    );
  }

  createReservation(body: ReservationPayload): Observable<any> {
    return this.#http.post<any>(`${environment.RESERVE_URL}/Reservation`, body);
  }

  putReservation(body: any): Observable<any> {
    return this.#http.put<any>(`${environment.RESERVE_URL}/Reservation`, body);
  }

  getBranchById(branchId: string): Observable<IBranchResponse> {
    return this.#http.get<IBranchResponse>(`${environment.RESERVE_URL}/Branch/${branchId}`);
  }

  getBranchOpeningHours(branchId: string): Observable<BranchStoreModality[]> {
    return this.#http.get<BranchStoreModality[]>(
      `${environment.RESERVE_URL}/Branch/${branchId}/OpeningHours`
    );
  }

  getOcasion(): Observable<any> {
    return this.#http.get<any>(`${environment.RESERVE_URL}/Occasion`);
  }

  verifyCPF(cpf: string): Observable<any> {
    return this.#http.get<any>(`${environment.RESERVE_URL}/Cashback/${cpf}`);
  }
}
